module.exports = __webpack_public_path__ + "img/poviewer-icon-disabled.3e7694be.svg";